import { checkEmailExists, emailIsNotValid } from "heliocor-ui"
import { db } from "../api/db"

const customValidations = {
  COMPANY_EXIST: async ({ value, validationDepValue, id }) => {
        if (!value || value === 0) return false
        const res = await db('get', `dokstor-cafe-api/api/self-onboarding/companies/registration-number/check?registration-number=${value}&country=${validationDepValue}`)
        return res.exists && { key: id, value: 'errors.companyAlreadyExist' }
  },
  EMAIL_IN_USE: async ({ value, id }) => {
        let readyToCheck = !emailIsNotValid(value)
        if (!value || !readyToCheck) return false
        return await checkEmailExists(value) && { key: id, value: 'errors.emailExist' }
  }
}

const getFieldsIdsArray = (fields) => Object
    .values(fields)
    .reduce((acc, val) => acc.concat(val), [])
    .map(field => field.id)


const isFieldVisible = (input, value) => {
  const verifyConditions = input.visibility.map(condition => {
        let res = value
        if (condition.hasOwnProperty('value')) {
            res = value === condition.value
        } else if (condition.values) {
            if (Array.isArray(value)) {
                res = value.some(c => condition.values.includes(c?.value || c))
            } else {
                res = condition.values.includes(value?.value || value)
            }
        }
        return res
  })
  return verifyConditions.every(field => field === true)
}


export {getFieldsIdsArray, isFieldVisible, customValidations}